import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./avenir-next/63a74598-733c-4d0c-bd91-b01bffcd6e69.ttf%22,%22variable%22:%22--font-avenir-next-medium%22}],%22variableName%22:%22avenirNextMedium%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'avenirNextMedium', 'avenirNextMedium Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
